import React, { useEffect } from 'react';
import { useLocation, useNavigate, Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchOrderRequest, fetchCartRequest, fetchCartCountRequest } from '../../modules/shop/actions';
import { Skeleton } from 'antd';
import { useTranslation } from 'react-i18next';

export default function OrderConfirmationPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  
  const orderId = location.state?.orderId;
  const { data: order, loading } = useSelector(state => state.shop.orderInfo);

  useEffect(() => {
    if (orderId) {
      dispatch(fetchOrderRequest(orderId));
    }
    dispatch(fetchCartRequest());
    dispatch(fetchCartCountRequest());
  }, [dispatch, orderId]);

  if (!orderId) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="w-full min-h-screen bg-[#fcfdfe] pt-20 pb-16 text-center flex flex-col items-center">
      <div className="max-w-[600px] w-full bg-white p-10 rounded-xl border border-gray-100 shadow-sm">
        <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6 text-3xl">
          ✓
        </div>
        <h1 className="text-3xl font-extrabold text-gray-900 mb-2">{t("text_order_confirmed")}</h1>
        <p className="text-gray-500 mb-8">{t("text_order_thank_you")}</p>
        
        <div className="bg-gray-50 p-6 rounded text-left mb-8">
          {loading ? (
            <Skeleton active paragraph={{ rows: 3 }} />
          ) : order ? (
            <>
              <p className="text-sm text-gray-500 mb-1">{t("text_order_num")}</p>
              <p className="font-bold text-gray-900 mb-4">{order.orderId || order._id}</p>
              <p className="text-sm text-gray-500 mb-1">{t("text_total_amount")}</p>
              <p className="font-bold text-[#e2005a]">¥{order.total?.toFixed(2)}</p>
            </>
          ) : (
            <p className="text-gray-500">{t("text_failed_loading_order_detail")}</p>
          )}
        </div>

        <div className="flex gap-4 justify-center">
          <button 
            onClick={() => navigate('/my-orders')}
            className="px-6 py-2 border border-gray-300 text-gray-700 font-semibold rounded hover:bg-gray-50 transition-colors"
          >
            {t("text_view_order")}
          </button>
          <button 
            onClick={() => navigate('/product')}
            className="px-6 py-2 bg-gradient-to-r from-[#1e295d] to-[#0d163d] text-white font-bold rounded shadow hover:opacity-90 transition-opacity"
          >
            {t("text_continue_shopping")}
          </button>
        </div>
      </div>
    </div>
  );
}
